import _toConsumableArray from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.map.js";
export function arrayUniqueByKey(array, key) {
  return _toConsumableArray(new Map(array.map(function (item) {
    return [item[key], item];
  })).values());
}